import alertIcon from "@loot-os/icons/icons/alert";
import { cardStyles } from "../../core/Card.styles.js";
import { Icon } from "../../core/Icon.js";

/** Why a section's records didn't load, written in their place. */
export function LoadError({ message }: { message: string }) {
  return (
    <p
      className={cardStyles({
        radius: "xl",
        className: "flex items-center gap-2 px-4 py-3 font-body text-body-b2 text-text-secondary",
      })}
    >
      <Icon icon={alertIcon} className="shrink-0 text-status-danger" />
      {message}
    </p>
  );
}
